<div class="dialog-wrapper">
    <ng-container>
        <div class="lottie-icon-wrapper" [ngClass.lt-sm]="'mobile'">
            <ng-lottie
                #animatedIcon
                class="animated-icon-anim"
                containerClass="animated-icon"
                [options]="{
                    path: this.assetBasePath + this.congratsLottieAnimation,
                    autoplay: true,
                    loop: true,
                }"></ng-lottie>
        </div>
        <div class="header">Thank You for Participating! <br /></div>
        <div class="msg">
            We really appreciate you being part of the video. You're all set! <br />
            If anything comes up, feel free to reach out.<br />
        </div>
        <div class="loading-text">Feel free to close this tab</div>

        <button class="close-button" color="default" mat-raised-button (click)="goBack()">Back</button>
    </ng-container>
</div>
